import { render, staticRenderFns } from "./MainPackage.vue?vue&type=template&id=3ce7a651&scoped=true&"
import script from "./MainPackage.vue?vue&type=script&lang=ts&"
export * from "./MainPackage.vue?vue&type=script&lang=ts&"
import style0 from "./MainPackage.vue?vue&type=style&index=0&id=3ce7a651&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce7a651",
  null
  
)

export default component.exports